import { Group, Stack, Text } from '@mantine/core';
import { CalendarClock } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { Badge, Card, Pill, Section } from '../ui';
import { useMyAssignments } from '../../hooks/useGradebook';

/** "Assigned to you" — labs the student's cohorts require, with due dates. */
export function AssignedLabsBanner() {
  const q = useMyAssignments();
  if (q.isPending || !q.data || q.data.length === 0) return null;
  const now = Date.now();
  return (
    <Section title="Assigned to you" description="Labs your cohort requires.">
      <Group gap="md" wrap="wrap">
        {q.data.map((a) => {
          const overdue = a.due_at ? new Date(a.due_at).getTime() < now : false;
          return (
            <Link key={`${a.cohort_id}:${a.lab_id}`} to="/labs/$id" params={{ id: a.lab_slug }} style={{ textDecoration: 'none' }}>
              <Card>
                <Stack gap={4}>
                  <Text size="sm" fw={600}>{a.lab_name}</Text>
                  <Group gap={6}>
                    {a.required ? <Badge variant="info" size="xs">required</Badge> : <Badge variant="neutral" size="xs">optional</Badge>}
                    {a.due_at ? (
                      <Pill variant={overdue ? 'danger' : 'warn'} size="xs">
                        <CalendarClock size={10} /> {overdue ? 'overdue' : `due ${new Date(a.due_at).toLocaleDateString()}`}
                      </Pill>
                    ) : null}
                  </Group>
                  <Text size="xs" c="dimmed">{a.cohort_name}</Text>
                </Stack>
              </Card>
            </Link>
          );
        })}
      </Group>
    </Section>
  );
}
